export const langKey = {};
